import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { OfflineIndicatorComponent } from './components/offline-indicator/offline-indicator.component';
import { fatalError } from './global-error-handler';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, CommonModule, OfflineIndicatorComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected title = 'users-app';
  isHomePage = false;
  readonly hasFatalError = fatalError;

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Sync from router state snapshot first to avoid layout shift on initial render
    this.isHomePage = this.router.routerState.snapshot.url === '/';

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe((e: NavigationEnd) => {
      this.isHomePage = e.urlAfterRedirects === '/';
    });
  }

  reloadPage(): void {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  }
}
